export default "__VITE_ASSET__CMjhBltl__"